import React, { useState } from 'react';
import DatasetDialog, { Field, inputClass, textareaClass, primaryClass, neutralClass } from 'features/datasets/components/DatasetDialog';

/** A name that says nothing is not a name: a draft is saved only once really named. */
export const isPlaceholderName = (n) => !String(n || '').trim() || /^untitled\b/i.test(String(n).trim());

/** Asks for the name (and an optional description) when a new dataset is first saved. */
export default function SaveDatasetDialog({ initialName = '', onSave, onClose }) {
  const [name, setName] = useState(initialName);
  const [description, setDescription] = useState('');
  const invalid = isPlaceholderName(name);
  return (
    <DatasetDialog title="Save dataset" onClose={onClose} width="max-w-[380px]"
      onSubmit={() => { if (!invalid) onSave({ name: name.trim(), description: description.trim() }); }}
      footer={(
        <>
          <button type="button" onClick={onClose} className={neutralClass}>Cancel</button>
          <button type="submit" disabled={invalid} className={primaryClass}>Save</button>
        </>
      )}>
      <Field label="Name" htmlFor="ds-save-name">
        <input id="ds-save-name" value={name} maxLength={120} autoFocus onChange={(e) => setName(e.target.value)} placeholder="refund-eval-set" className={inputClass} />
      </Field>
      <Field label="Description" htmlFor="ds-save-desc">
        <textarea id="ds-save-desc" rows={3} value={description} maxLength={2000} onChange={(e) => setDescription(e.target.value)} placeholder="What these rows test" className={textareaClass} />
      </Field>
    </DatasetDialog>
  );
}
